import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { OfferStatusTag } from '../../../../common/OfferStatusTag/OfferStatusTag';
import { ReadOnlyProductTable } from '../../../../common/ReadOnlyProductTable/ReadOnlyProductTable';
import { Section } from '../../../../common/Section/Section';
import { Box } from '../../../../common/ui/Box';
import { OfferModel } from '../../../model/OfferModel';
import { OfferDatasheet } from '../../../OfferCoreData/OfferDatasheet';
import { InvolvedParties } from '../../common/components/InvolvedParties';

type OfferHistorySnapshotMode = 'before' | 'after';

interface OfferHistorySnapshotViewProps {
    offer: OfferModel;
    actorName?: string;
    timestamp: string;
    revision: OfferHistorySnapshotMode;
}

const getRevisionTitle = (revision: OfferHistorySnapshotMode) => {
    if (revision === 'before') {
        return translate('offer.history.snapshot.beforeTitle');
    }

    return translate('offer.history.snapshot.afterTitle');
};

export const OfferHistorySnapshotView = ({ offer, revision }: OfferHistorySnapshotViewProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={32}>
            <Box display="flex" flexDirection="column" gap={12}>
                <Box display="flex" alignItems="center" justifyContent="space-between" gap={16} flexWrap="wrap">
                    <Text variant="title">{getRevisionTitle(revision)}</Text>
                    <OfferStatusTag state={offer.state} variant="customer" />
                </Box>
            </Box>

            <InvolvedParties offer={offer} />

            <Section title={translate('offer.detail.details')} fullHeight={false}>
                <OfferDatasheet offer={offer} />
            </Section>

            <Section title={translate('offer.history.section.products')} fullHeight={false}>
                <ReadOnlyProductTable
                    items={offer.items}
                    surcharges={offer.surcharges}
                    sampleKits={offer.samplekits}
                    totals={{
                        volume: offer.volume,
                        price: offer.ppl,
                        total: offer.total,
                    }}
                    showPrices
                />
            </Section>
        </Box>
    );
};
